// src/pages/CheckPanelShell.js
// 進出場管理頁面（複製自 MemberPanelShell，左欄改為 AttendancePanel）
import React, { useRef } from 'react';
import AttendancePanel from './AttendancePanel';
import CheckOpsPanel from './CheckOpsPanel';
import BanquetInfoPlaceholder from './BanquetInfoPlaceholder';

function useNarrow() {
  const [narrow, setNarrow] = React.useState(() => typeof window !== 'undefined' && window.innerWidth < 768);
  React.useEffect(() => {
    const onR = () => setNarrow(window.innerWidth < 768);
    window.addEventListener('resize', onR);
    return () => window.removeEventListener('resize', onR);
  }, []);
  return narrow;
}

export default function CheckPanelShell() {
  const attendanceRef = useRef(null);
  const narrow = useNarrow();

  return (
    <div style={{
      ...page,
      height: narrow ? 'auto' : '100%',
      gridTemplateColumns: narrow ? '1fr' : '1fr 1.4fr 1fr',
    }}>
      <section style={narrow ? colWrapNarrow : colWrap}>
        <AttendancePanel ref={attendanceRef} />
      </section>

      <section style={narrow ? colWrapNarrow : colWrap}>
        <CheckOpsPanel
          fullBleed
          onAttendanceScan={() => attendanceRef.current?.refresh?.()}
        />
      </section>

      <section style={narrow ? colWrapNarrow : colWrap}>
        <BanquetInfoPlaceholder todayOnly={true} />
      </section>
    </div>
  );
}

const GAP = 0;

const page = {
  height: '100%',
  width: '100%',
  display: 'grid',
  gridTemplateColumns: '1fr 1.4fr 1fr',
  gap: GAP,
  boxSizing: 'border-box',
  minHeight: 0,
  position: 'relative',
};

const colWrap = {
  minWidth: 0,
  minHeight: 0,
  height: '100%',
  border: '1px solid #e7e7e7',
  borderRadius: 8,
  background: '#fff',
  padding: 4,
  overflow: 'hidden',
  boxSizing: 'border-box',
};

const colWrapNarrow = {
  ...colWrap,
  height: '70vh',
  minHeight: 420,
  maxWidth: '100%',
  overflow: 'auto',
  WebkitOverflowScrolling: 'touch',
};
